<script setup lang="ts">
import { PebbleWebsiteNavbar } from "#components";
</script>

<template>
  <PebbleWebsiteNavbar />
  <div class="flex min-h-svh flex-col bg-background-dark overflow-x-hidden">
    <main class="w-full flex-1">
      <slot />
    </main>
  </div>
</template>
